import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import {
  getDefaultPagination,
  handleSuccess,
  handleApiErrorWithFallback,
  handleError,
} from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const ApplicationApi = {
  getApplications: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }

    return AxiosClient.post(`/application/v1/read?${queryParams}`, [])
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.ApplicationKey
        );
      });
  },

  createApplication: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/application/v1/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  updateApplication: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/application/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  deleteApplications: (action: { request: string[] }, dispatch: Dispatch) => {
    return AxiosClient.post('/application/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getApplicationDetails: (
    action: { request: string[]; isActive?: boolean },
    dispatch: Dispatch
  ) => {
    let queryParams = action.request.length === 0 ? getDefaultPagination() : '';
    if (action.isActive !== undefined) {
      queryParams += (queryParams ? '&' : '') + `isActive=${action.isActive}`;
    }

    return AxiosClient.post('/application/v1/read?' + queryParams, action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },
};
